// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3kZCg","footer":"ModalUpdate_footer__2b-vH"};